module.exports = __webpack_public_path__ + "img/全钢通风柜.60830f60.jpg";